import Axios from 'axios';

import {
	SELF_FILES_LOADING_TRUE,
	SELF_FILES_LOADING_FALSE,
	SELF_FILES_LATEST_GET,
	SELF_FILES_LATEST_ERROR
} from './types';

import create_query_params from '../utils/create_query_params';

// Loading actions
const self_files_loading_true = () => {
	return {
		type: SELF_FILES_LOADING_TRUE
	}
}

const self_files_loading_false = () => {
	return {
		type: SELF_FILES_LOADING_FALSE
	}
}

// Get latest self files
export const get_self_files_latest = (filters) => dispatch => {
	dispatch(self_files_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + '/api/self/files/latest?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: SELF_FILES_LATEST_GET,
			payload: res.data
		});
		dispatch(self_files_loading_false());
	})
	.catch((err) => {
		dispatch({
			type: SELF_FILES_LATEST_ERROR,
			payload: err.response?.data || err.message
		});
		dispatch(self_files_loading_false());
	});
}
